

import React from 'react';
import './Teampermissions.scss';
import { FaTrashAlt, FaLock, FaEye } from 'react-icons/fa';

const teamData = [
  {
    name: 'Osama Alabayre',
    level: 'HR Admin',
    accountDate: '06-03-2021',
    roleDate: '06-03-2021',
  },
   {
    name: 'Osama Alabayre',
    level: 'HR Admin',
    accountDate: '06-03-2021',
    roleDate: '06-03-2021',
  },
   {
    name: 'Osama Alabayre',
    level: 'HR Admin',
    accountDate: '06-03-2021',
    roleDate: '06-03-2021',
  },
   {
    name: 'Osama Alabayre',
    level: 'HR Admin',
    accountDate: '06-03-2021',
    roleDate: '06-03-2021',
  },
   {
    name: 'Osama Alabayre',
    level: 'HR Admin',
    accountDate: '06-03-2021',
    roleDate: '06-03-2021',
  },
  // كرر حسب الحاجة
];

export default function Teampermissions() {
  return (
    <div className="work-team-table p-3">
      <p className="table-title">Work Team Permissions</p>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Level</th>
            <th>Account Created Date</th>
            <th>Role Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className=' container'>
          {teamData.map((user, index) => (
            <tr key={index}>
              <td>{user.name}</td>
              <td>{user.level}</td>
              <td>{user.accountDate}</td>
              <td>{user.roleDate}</td>
              <td className="actions">
                <FaTrashAlt className="icon delete" />
                <FaLock className="icon lock" />
                <FaEye className="icon view" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
